module.exports = __webpack_public_path__ + "cash_flow.1f78425f424bf9d8b2b3cf69cd93ee33.svg";